import React from 'react'
import { createRoot } from 'react-dom/client'
import cookies from 'js-cookie'

export interface SubmitFormItem {
  readonly name: string
  readonly value: string
}

export function submitForm(
  url: string,
  data?: SubmitFormItem[],
  baseURL?: string
) {
  const container = document.createElement('div')
  document.body.appendChild(container)

  const root = createRoot(container)
  const formId = `${url}-form`

  root.render(
    <form
      action={`${baseURL ? baseURL : '/Contrast/api/ng'}${
        url.startsWith('/') ? url : `/${url}`
      }`}
      method="POST"
      id={formId}
    >
      {data &&
        data.map(({ name, value }) => (
          <input
            type="hidden"
            key={`${name}-${value}`}
            name={name}
            value={value}
          />
        ))}
      <input name="X-XSRF-TOKEN" value={cookies.get('XSRF-TOKEN')} readOnly />
    </form>
  )

  // Wait for the form element to be in the DOM
  const observer = new MutationObserver(() => {
    if (container.contains(document.getElementById(formId))) {
      try {
        ;(container.firstChild as HTMLFormElement).submit()
      } finally {
        document.body.removeChild(container)
        root.unmount()
        observer.disconnect()
      }
    }
  })
  observer.observe(container, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true
  })
}
